import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { frameParamsAtom } from 'src/app/state/atoms';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { sendLaunchEvent } from 'src/app/lib/google-analytics';
import { isTelemetryEnabled } from 'src/app/utils/getTelemetrySwitch';
import { getRuntimeEnvironment } from 'src/app/utils/getRuntimeEnvironment';

function useGaChatOpened() {
  const [frameParams] = useRecoilState(frameParamsAtom);

  useEffect(() => {
    //Send the launch event
    if (frameParams.exercise_id && !isTelemetryEnabled() && getRuntimeEnvironment() === 'prod') {
      sendLaunchEvent(frameParams);
    }
  }, [frameParams]);
}

export default useGaChatOpened;
